const state = () => ({
  tenant: localStorage.getItem("tenant") || "agents",
  showErrorDialog: false,
  errorDialogData: null
});

const getters = {
  getErrorDialogState: state => state.showErrorDialog,
  getErrorDialogData: state => state.errorDialogData,
  getTenant: state => state.tenant
};

const mutations = {
  thisTenant(state, data = "agents") {
    state.tenant = data;
  },
  errorDialogState(state, data = false) {
    state.showErrorDialog = data;
  },
  errorDialogData(state, data = null) {
    state.errorDialogData = data;
  }
};

const actions = {
  setTenant({ commit }, payload) {
    commit("thisTenant", payload);
    localStorage.setItem("tenant", payload);
  },
  setErrorDialogData({ commit }, payload) {
    commit("errorDialogData", payload);
    commit("errorDialogState", true);
  },
  clearErrorDialogData({ commit }) {
    commit("errorDialogData", null);
    commit("errorDialogState", false);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
